
import { defineComponent } from "vue";
import QR from "@/components/QR.vue";
import TicketFlightInfo from "./TicketFlightInfo.vue";
import TicketHeader from "./TicketHeader.vue";
import TicketRoute from "./TicketRoute.vue";
import { TicketInfo } from "@/Models/ticket";

export default defineComponent({
  components: {
    TicketHeader,
    TicketRoute,
    TicketFlightInfo,
    QR,
  },
  name: "Ticket",
  props: {
    ticket: TicketInfo,
  },
});
